/**
 * Formula Breakdown — popup + Swiper carousel (mobile)
 */
(function () {
  var MOBILE = 750;
  var dataEl = document.querySelector('[data-formula-ingredients]');
  var ingredients = dataEl ? JSON.parse(dataEl.textContent) : [];

  // ── Popup custom element ──
  class FormulaPopup extends HTMLElement {
    connectedCallback() {
      this._image = this.querySelector('[data-image]');
      this._title = this.querySelector('[data-title]');
      this._details = this.querySelector('[data-details]');
      this.querySelectorAll('[data-popup-close]').forEach(
        function (el) {
          el.addEventListener('click', this.close.bind(this));
        }.bind(this),
      );
    }

    open(index) {
      var ing = ingredients[index];
      if (!ing) return;
      if (ing.image) {
        this._image.src = ing.image;
        this._image.alt = ing.name;
        this._image.style.display = '';
      } else {
        this._image.style.display = 'none';
      }
      this._title.textContent =
        ing.name + (ing.dosage ? ' (' + ing.dosage + ')' : '');
      this._details.innerHTML = ing.details
        .map(function (d) {
          return (
            '<div data-detail-item>' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none">' +
            '<path d="M10 18.33C14.6 18.33 18.33 14.6 18.33 10C18.33 5.4 14.6 1.67 10 1.67C5.4 1.67 1.67 5.4 1.67 10C1.67 14.6 5.4 18.33 10 18.33Z" stroke="#ACA38A" stroke-width="1.25" stroke-dasharray="4 4"/>' +
            '<path d="M7.08 10.42L8.75 12.08L12.92 7.92" stroke="#362408" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg><span>' +
            d +
            '</span></div>'
          );
        })
        .join('');
      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  customElements.define('one-formula-popup', FormulaPopup);

  // ── Popup open handler ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-popup-open]');
    if (btn) {
      var popup = document.querySelector('one-formula-popup');
      if (popup) popup.open(parseInt(btn.getAttribute('data-popup-open'), 10));
    }
  });

  // ── Swiper init (mobile only) ──
  var swiperInstance = null;

  function initSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initSwiper, 100);
      return;
    }
    if (swiperInstance) return;

    var el = document.querySelector('[data-formula-swiper]');
    if (!el) return;

    swiperInstance = new Swiper(el, {
      slidesPerView: 2,
      grid: {
        rows: 3,
        fill: 'row',
      },
      spaceBetween: 8,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }

  function destroySwiper() {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  function handleResize() {
    if (window.innerWidth < MOBILE) {
      initSwiper();
    } else {
      destroySwiper();
    }
  }

  handleResize();
  window.addEventListener('resize', handleResize);
})();
